<template>
<main class="main-wrapper flex-grow-1">
<div class="d-flex align-items-center bg-white">
		<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1">
				{{$t('1371')}}
		</div>
</div>
<div class="divider"></div>
<div class="container container--narrow pdt-50">
		<div class="t-center">
			<img alt="" class="exam-image mgx-auto" src="/images/result-image.svg">
			<div class="t-headline15 font-b t-line-h-33 mgt-8">{{$t('1372')}}</div>
			<div class="mgt-8 t-body6 t-center font-r t-color-bodyGrayA t-line-h-22">
				{{$t('1373')}}<br>
				{{$t('1374')}}
			</div>
		</div>
		<div class="divider mgt-30"></div>
		<div class="mgt-24 t-headline10 font-b t-line-16">{{$t('1375')}}</div>
		<div class="d-grid-3-24 mgb-24 mgt-16">
				<div class="mdc-card pda-24">
						<div class="t-center t-headline9 font-b t-line-h-29">{{countTotal}}</div>
						<div class="t-body6 t-center t-line-h-20 font-r t-color-bodyGrayA mgt-8">{{$t('1376')}}</div>
				</div>
				<div class="mdc-card pda-24">
						<div class="t-center t-headline9 font-b t-line-h-29">{{countCorrect}}</div>
						<div class="t-body6 t-center t-line-h-20 font-r t-color-bodyGrayA mgt-8">{{$t('1377')}}</div>
				</div>
				<div class="mdc-card pda-24">
					<div class="t-center t-headline9 font-b t-line-h-29">{{countIncorrect}}</div>
					<div class="t-body6 t-center t-line-h-20 font-r t-color-bodyGrayA mgt-8">{{$t('1378')}}</div>
				</div>
		</div>

		<div class="mdc-card pdt-10 pdb-10 pdl-24 pdr-24 ">
			<div class="d-flex align-items-center justify-content-between ">
				<div class="t-subtitle3 font-m  t-line-h-22">
					{{$t('1379')}}
				</div>
				<button class="mdc-icon-button content-trigger mgr--12"  tabindex="0" @click="toggleQuestionViewStatus()">
					<i class="material-icons t-headline12 t-color-bodyGrayA">{{questionViewStatus ? 'expand_less' : 'expand_more'}}</i>
				</button>
			</div>
			<div v-show="questionViewStatus" class="detail-content w-full mgt-24">
				<div class="d-flex flex-wrap result">
					<div v-for="(question, index) in questions" :key="index"
									:class="question.correct === true ? 'correct' : 'incorrect'"  class="t-subtitle2 t-line-h-24 t-center t-color-disableBtn min-w-32 pdl-15 mgr-24 mgb-21 position-relative question">
									{{index+1}}
					</div>
				</div>
			</div>
		</div>

		<div class="mdc-card  mgb-24 pda-24 mgt-24">
      <div class="position-relative">
        <div :style="`${direction === 'ltr' ? 'left': 'right'}:${standard}%;`" class="dashed-line-vertical"></div>
        <div class="percentage-wrapper">
          <div class="d-flex justify-content-between align-items-center">
            <div class="t-color-lecturePurple t-helper font-r">{{$t('1380')}}</div>
            <div class="d-flex align-items-baseline">
              <div class="percent-number t-color-lecturePurple t-subtitle1 l-spacing6 font-b mgr-4 ">
                {{`${scoreMy}`}}</div>
              <div class="t-color-lecturePurple t-helper font-r">{{$t('91', {str: ''})}}</div>
            </div>
          </div>
          <div class="h-2 position-relative total-percentage mgt-1 mgb-20 bg-iconinactiveText">
            <div :style="`width:${scoreMy}%;`" class="real-percentage bg-lecturePurple h-6 ">
            </div>
          </div>
        </div>
        <div class="percentage-wrapper">
          <div class="d-flex justify-content-between align-items-center">
            <div class="t-color-iconInactive t-helper font-r">{{$t('1382')}}</div>
            <div class="d-flex align-items-baseline">
              <div class="percent-number t-color-iconInactive t-subtitle1 l-spacing6 font-b mgr-4 ">
                {{`${averageScore}`}}
              </div>
              <div class="t-helper t-color-iconInactive font-r">{{$t('91', {str: ''})}}</div>
            </div>
          </div>
          <div class="h-2 position-relative total-percentage mgt-5 bg-iconinactiveText">
            <div :style="`width:${averageScore}%;`"  class="real-percentage bg-iconInactive h-6">
            </div>
          </div>
        </div>
      </div>
		</div>
<div v-if="getTotalPoint === 0">
		<div class="mgt-60 t-headline10 font-b t-line-16">{{$t('1385')}}</div>
		<div class="mdc-card  mgb-24 pdt-24 pdb-24 pdl-24 pdr-24 mgt-24">
			<div class=" ">
				<div class="d-flex">
					<div class="t-body6 font-b l-spacing48 flex-grow-1">
						{{$t('1386')}}
					</div>
					<div>
						<!-- <span class="t-subtitle2 font-rm">{{$t('1387', {str: getTotalPoint})}}</span>  -->
						<span class="t-body6 font-r t-color-bodyGrayA pdl-3">{{$t('1387', {str: getTotalPoint})}}</span>
					</div>
				</div>
			</div>
		</div>
</div>
		<div class="mgt-50">
			<button v-for="(action, index) in examActions"
			:key="index" :class="setButtonDisabled(action) ? 'bg-disableBtn t-color-disableBtnText disabled': 'bg-mainBtn t-color-mainBtnText mdc-button--raised'"
			:disabled="setButtonDisabled(action)" class="mdc-button b-radius4 mgr-8" tabindex="0"
			@click="examAction(action)">
				<div class="mdc-button__ripple"></div>
				<span class="mdc-button__label t-body2 font-r">{{setButtonActionName(action)}}</span>
			</button>
			<div class="mgb-50"></div>
		</div>
</div>
</main>
</template>

<script>
/**
 * 시험 결과 컴포넌트(exam result component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import microExamApi from "@/api/microExamApi";
import {microExamMixin} from "@/mixins/microExam";

export default {
	data() {
		return {
			countTotal: 0,
			countCorrect: 0,
			countIncorrect: 0,
			scoreMy: 0,
			questions: null,

			questionViewStatus: true,

			examActions: [],
			paperId: 0,

			scoreData: null,
			averageScore: 0,
			standard: 0,

			applicationEarnPoint: 0,
			solveAllEarnPoint: 0,
			getTotalPoint: 0,
			direction:"ltr"
		}
	},

	mixins: [microExamMixin],

	mounted() {
		this.direction = document.querySelector('html').getAttribute('dir');
		let responseData = null
		let params = {
			examineeId: this.$route.params.examineeId
		}

		// 시험 응시 기록 조회(get exam submited list)
		microExamApi.submitedList(params).then((response) => {
			responseData = response.data.data

			// 마지막 응시 기록(get last submited data)
			let lastSubmitData = _.head(responseData)

			this.paperId = lastSubmitData.id

			params = {
				examineeId: this.$route.params.examineeId,
				paperId: this.paperId
			}

			// 응시 결과 조회(get exam result)
			microExamApi.result(params).then((response) => {
				responseData = response.data.data
				this.countTotal = responseData.count.total
				this.countCorrect = responseData.count.correct
				this.countIncorrect = responseData.count.incorrect

				this.applicationEarnPoint = responseData.applicationEarnPoint
				this.solveAllEarnPoint = responseData.solveAllEarnPoint
				this.getTotalPoint = this.applicationEarnPoint + this.solveAllEarnPoint

				this.scoreMy = responseData.score

				this.questions = _.chain(responseData.groups)
					.map((item) => {
						return item.questions
					})
					.flatten()
					.map((question, index) => {
						return question
					}).value()
			}).catch((err) => {})

			// 시험 점수 정보(get exam score data)
			microExamApi.score(params).then((response) => {
				this.scoreData = response.data.data
				this.averageScore = parseInt(this.scoreData.averageScore)
				this.standard = parseInt(this.scoreData.standard)
			}).catch((err) => {})

			// 시험 인트로 정보(get exam intro information)
      microExamApi.examIntro(params).then((response) => {
				this.examData = response.data.data
				this.examActions = this.examData.actions
			}).catch((err) => {})
		}).catch((err) => {})
	},

	methods: {
		// 시험 응시 종료 팝업(take exam close popup)
		closeExamTake() {
			this.$confirm({
				//title: this.$t('TODO-시험을 종료하시겠습니까?'),
				content: this.$t('50022'),  //시험 피드백 보기를 종료하시겠습니까?
				accept:  this.$t('50023'),  // 확인
				cancel:  this.$t('50024'),  // 취소
			}).then(() => {
				this.$router.push({
					name: this.$route.matched[this.$route.matched.length-2].name,
					params: this.$route.params,
					query: {status:this.$route.query.status,examresult:'getscore'}
				})
			}).catch(() => {})
		},

		toggleQuestionViewStatus() {
			this.questionViewStatus = !this.questionViewStatus
		},

		setButtonActionName(action) {
			//before_start : ~부터 응시가능
			//can_start : 응시
			//can_re_start : 재응시
			//before_confirm : ~부터 결과확인 가능
			//open_confirm : 결과확인
			let buttonName = ''
			if (action.action === 'before_start') {
				buttonName = this.$t('50010', {str: action.data.application_start_time}) //  + '{날짜}부터 응시가능
			}else if (action.action === 'can_start') {
				buttonName = this.$t('50008') //'응시(take)
			}else if (action.action === 'can_re_start') {
				buttonName = this.$t('1390') //재응시(retake)
			}else if (action.action === 'before_confirm') {
				buttonName = this.$t('50011', {str: action.data.confirm_start_time}) // '{날짜}부터 결과확인 가능
			}else if (action.action === 'open_confirm') {
				buttonName = this.$t('1388') //'결과확인(show result)
			}
			return buttonName
		},

		setButtonDisabled(action) {
			return action.action === 'before_start' || action.action === 'before_confirm'
		},

		examAction(action) {
			if (action.action === 'can_start' || action.action === 'can_re_start') {
				// move exam take
				this.startExam()
			}else if (action.action === 'open_confirm') {
				// move exam feedback
				this.moveExamFeedback()
			}
		},

	}
}
</script>
